module.exports = __webpack_public_path__ + "static/media/galdisa_servicios_bg.fb19e178.jpg";